// Multi-shop -- translated labels and formatting (menuElakay_<lang>.json ->
// frontElakayAutoText). Keys never change with the displayed text.
import { elakayAutoText as text, elakayIntlLocale } from "../pageInside/dataElakay";

export const shopTypeLabel = (type) => (type === "provider"
  ? text("h_msh_type_provider", "Provider / Producer shop")
  : text("h_msh_type_seller", "Seller shop"));

export const roleLabel = (role) => ({
  Seller: text("h_msh_role_seller", "Seller"),
  Provider: text("h_msh_role_provider", "Provider / Producer"),
  Associate: text("h_msh_role_associate", "Associate"),
  Investment: text("h_msh_role_investor", "Investor"),
  Administrator: text("h_msh_role_administrator", "Administrator"),
  Family: text("h_msh_role_family", "Developer"),
}[role] || role);

export const formatMoney = (amount, currency = "usd") => {
  try {
    return new Intl.NumberFormat(elakayIntlLocale?.() || "en-US", { style: "currency", currency: String(currency || "usd").toUpperCase() }).format(Number(amount) || 0);
  } catch {
    return `${(Number(amount) || 0).toFixed(2)} ${String(currency || "usd").toUpperCase()}`;
  }
};

export const formatShopPrice = (pricing) => (pricing?.required
  ? formatMoney(pricing.amount, pricing.currency)
  : text("h_msh_free", "Free"));

const ERRORS = () => ({
  MAX_SHOPS_REACHED: text("h_msh_max_reached", "Maximum shops reached."),
  SHOP_TYPE_NOT_ALLOWED: text("h_msh_err_type", "Your role cannot create this type of shop."),
  INVALID_NAME: text("h_msh_name_length", "The shop name must be 2 to 80 characters."),
  INVALID_ADDRESS: text("h_msh_err_address", "The shop address is incomplete."),
  PRICE_CHANGED: text("h_msh_err_price_changed", "The shop price changed. Please check the new price and confirm again."),
  NO_CUSTOMER: text("h_msh_err_no_card", "Add a payment card in your wallet to create a paid shop."),
  NO_CARD: text("h_msh_err_no_card", "Add a payment card in your wallet to create a paid shop."),
  CARD_DECLINED: text("h_msh_err_declined", "Your card was declined. No shop was created."),
  PAYMENT_FAILED: text("h_msh_err_payment", "The payment failed. No shop was created."),
  PAYMENT_NOT_COMPLETED: text("h_msh_err_payment", "The payment failed. No shop was created."),
  PAYMENT_MISMATCH: text("h_msh_err_payment", "The payment failed. No shop was created."),
  SHOP_NOT_ACTIVE: text("h_msh_err_not_active", "This shop is waiting for its payment confirmation."),
  FAMILY_ONLY: text("h_msh_err_family_only", "Only users with the Developer role can change Shop Management."),
});

export const shopErrorMessage = (error) => ERRORS()[error?.code] || error?.message || text("h_msh_err_generic", "Something went wrong. Please try again.");

// Errors from shop lifecycle/follow/price operations use translated messages.
export const shopOperationError = (error) => ({
  NOT_FOUND: text("h_msl_err_unavailable", "Shop not available."),
  SHOP_NOT_ACTIVE: text("h_msl_err_unavailable", "Shop not available."),
  FORBIDDEN: text("h_msl_err_forbidden", "You do not have permission to perform this action."),
  SHOP_TYPE_NOT_ALLOWED: text("h_msl_err_forbidden", "You do not have permission to perform this action."),
  PRODUCT_SHOP_MISMATCH: text("h_msl_err_forbidden", "You do not have permission to perform this action."),
  INVALID_PRICE: text("h_msl_err_price_invalid", "Enter a valid positive price."),
  UNPROFITABLE_PRICE: text("h_msl_err_price_profit", "This price does not meet the existing profitability rules."),
  EXTERNAL_MANAGED: text("h_msl_err_external_price", "Imported product prices are managed by the supplier pricing system."),
  RESTORE_EXPIRED: text("h_msl_err_restore_expired", "The seven-day restoration window has expired."),
  INVALID_DESTINATION: text("h_msl_err_destination_invalid", "Select another active shop of the same type that you own."),
  INVALID_IMAGE: text("h_msl_err_image_invalid", "Use valid HTTP or HTTPS image URLs, with at most five slider images."),
  INVALID_IMAGES: text("h_msl_err_image_invalid", "Use valid HTTP or HTTPS image URLs, with at most five slider images."),
  INVALID_IMAGE_URL: text("h_msl_err_image_invalid", "Use valid HTTP or HTTPS image URLs, with at most five slider images."),
  OWN_SHOP: text("h_msl_err_own_follow", "You cannot follow your own shop."),
}[error?.code] || ERRORS()[error?.code] || text("h_msh_err_generic", "Something went wrong. Please try again."));
